import { useQueryClient } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';
import { AppContext } from '../../config';
import { BusinessContextModel } from '../../model/BusinessContext.model';
import { extractErrorMessageFromError } from '../../utils';

type Props = {
  businessContext: BusinessContextModel | null;
}

export const AppQueryClientBusinessContextSwitcher = ({ businessContext }: Props): null => {
  const queryClient = useQueryClient();
  const { setLoaderVisibility, showAlert } = useContext(AppContext);

  useEffect(() => {
    queryClient.setDefaultOptions({
      queries: {
        ...queryClient.getDefaultOptions().queries,
      },
      mutations: {
        ...queryClient.defaultMutationOptions(),
        onMutate: () => {
          setLoaderVisibility(true);
        },
        // stop success
        onSuccess: () => {
          setLoaderVisibility(false);
        },
        // stop failure
        onError: (error) => {
          showAlert({
            severity: 'error',
            title: 'Wystąpił błąd',
            description: extractErrorMessageFromError(error, businessContext?.queries || null),
            autoHide: true
          });
          console.error(error);
          setLoaderVisibility(false);
        },
      },
    });

    queryClient.getQueryCache().config.onError = (error) => {
      showAlert({
        severity: 'error',
        title: 'Wystąpił błąd',
        description: extractErrorMessageFromError(error, businessContext?.queries || null),
        autoHide: true
      });
      console.error(error);
    };
  }, [businessContext, queryClient, setLoaderVisibility, showAlert]);

  return null;
};
